import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { useRef } from 'react';

export const AbvMediShaPerspective = () => {

const entityPerspectiveRef = useRef();

const views = [ {
      name: 'Payments',
      dims: ['PERIOD', 'PROD', 'STATE'],
      kpis: ['TRX_COUNT', 'TRX_QTY'],
      dimToPeriodicities: {
        PERIOD: ['LIFETIME', 'YEAR', 'QTR', 'MON']
      }
    }];

  return (
    <EntityPerspective 
     ref={entityPerspectiveRef} 
     views={views}
     />
  )
}